import { Box, Pressable, Text, VStack } from 'native-base'

import { colors } from '../../utils/theme/configureTheme'

interface OptionChipsProps {
  options: readonly string[]
  selected: string[]
  onChange: (selected: string[]) => void
  columns?: 1 | 2
  fontSize?: number
  numberOfLines?: number
}

/** Multi-select chip group for choosing from a list of labeled options. */
export default function OptionChips({
  options,
  selected,
  onChange,
  columns = 1,
  fontSize,
  numberOfLines,
}: OptionChipsProps) {
  const toggleChip = (option: string) => {
    if (selected.includes(option)) {
      onChange(selected.filter(s => s !== option))
    } else {
      onChange([...selected, option])
    }
  }

  if (columns === 2) {
    return (
      <Box mt={2} mb={1} flexDirection="row" flexWrap="wrap" mx={-1}>
        {options.map(option => {
          const isSelected = selected.includes(option)
          return (
            <Box key={option} width="50%" px={1} mb={2}>
              <Pressable onPress={() => toggleChip(option)}>
                <Box
                  borderWidth={isSelected ? 2 : 1}
                  borderColor={isSelected ? '#3B5466' : colors.gray[100]}
                  backgroundColor={isSelected ? colors.brand.lightBlue : colors.brand.white}
                  borderRadius={100}
                  px={3}
                  py={2.5}
                  alignItems="center"
                >
                  <Text
                    fontSize={fontSize ?? 12}
                    fontWeight={isSelected ? '600' : '400'}
                    color={colors.brand.softBlack}
                    fontFamily="Matter Regular"
                    textAlign="center"
                    numberOfLines={numberOfLines}
                  >
                    {option}
                  </Text>
                </Box>
              </Pressable>
            </Box>
          )
        })}
      </Box>
    )
  }

  return (
    <VStack space={2} mt={2} mb={1}>
      {options.map(option => {
        const isSelected = selected.includes(option)
        return (
          <Pressable key={option} onPress={() => toggleChip(option)}>
            <Box
              borderWidth={isSelected ? 2 : 1}
              borderColor={isSelected ? '#3B5466' : colors.gray[100]}
              backgroundColor={isSelected ? colors.brand.lightBlue : colors.brand.white}
              borderRadius={100}
              px={4}
              py={2.5}
              alignItems="center"
            >
              <Text
                fontSize={fontSize ?? 14}
                fontWeight={isSelected ? '600' : '400'}
                color={colors.brand.softBlack}
                fontFamily="Matter Regular"
                numberOfLines={numberOfLines}
              >
                {option}
              </Text>
            </Box>
          </Pressable>
        )
      })}
    </VStack>
  )
}
